import { useState } from 'react';
import Axios from '../utils/axiosInstance';

const useSearch = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = async (query) => {
    setLoading(true);
    setError(null);

    try {
      const apiUrl = `${process.env.REACT_APP_API_BASE_URL}collection/search/?q=${query}&itemsPerPage=6`;
      const response = await Axios.get(apiUrl);
      if (response.data) {
        return response.data;
      } else {
        throw new Error('No data found');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { search, loading, error };
};

export default useSearch;
